import React from 'react';

const pdfs = [
  { name: 'Q1 Report', size: '4.2 MB' },
  { name: 'Model v3', size: '1.8 MB' },
  { name: 'Pitch Deck', size: '8.1 MB' },
  { name: 'Comps', size: '2.3 MB' },
  { name: 'Due Diligence', size: '5.6 MB' },
  { name: 'Memo', size: '320 KB' },
];

const PDFPagePlaceholder: React.FC = () => (
  <svg width="20" height="24" viewBox="0 0 28 36">
    <path d="M2 0h16l10 10v24a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z" fill="#d1d5db" />
    <path d="M18 0l10 10h-8a2 2 0 01-2-2V0z" fill="rgba(0,0,0,0.1)" />
    <rect x="6" y="14" width="16" height="1.5" rx="0.75" fill="#9ca3af" />
    <rect x="6" y="18" width="12" height="1.5" rx="0.75" fill="#9ca3af" />
    <rect x="6" y="22" width="14" height="1.5" rx="0.75" fill="#9ca3af" />
  </svg>
);

const Preview: React.FC = () => (
  <div className="h-full bg-surface flex flex-col overflow-hidden">
    {/* Header */}
    <div className="px-3 py-2 border-b bg-neutral-50 flex items-center justify-between gap-2">
      <div className="flex-1">
        <div className="h-5 bg-surface border border-neutral-200 rounded text-[8px] text-neutral-400 px-1.5 flex items-center">
          Search...
        </div>
      </div>
      <div className="text-[8px] text-neutral-500 flex-shrink-0">6 PDFs</div>
      <div className="h-5 px-1.5 bg-primary-600 text-white text-[8px] rounded flex items-center gap-0.5 flex-shrink-0">
        <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        Upload
      </div>
    </div>

    {/* Grid */}
    <div className="flex-1 overflow-hidden p-2">
      <div className="grid grid-cols-3 gap-1.5">
        {pdfs.map(pdf => (
          <div key={pdf.name} className="rounded border border-neutral-200 overflow-hidden">
            <div className="w-full aspect-[3/4] bg-neutral-100 flex items-center justify-center">
              <PDFPagePlaceholder />
            </div>
            <div className="px-1.5 py-1 bg-surface">
              <div className="text-[9px] font-medium text-neutral-900 truncate">{pdf.name}</div>
              <div className="text-[8px] text-neutral-500">{pdf.size}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Preview;
